import { Store } from 'vuex';

export function trackBetBuilderFeatureFlags(store: Store<unknown>) {
    return store.dispatch('data/betBuilder/initializeBetBuilder', null, { root: true });
}
